// atagon GmbH
// Generated API client for ApiToken
// Do not change it manually; use the Code Generator plugin instead. (Look at the code of the server providing the api)

// atagon GmbH
// Generated API client for ApiToken
// Do not change it manually; use the Code Generator plugin instead. (Look at the code of the server providing the api)


/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import Fetch from "toolbox/fetch";
import SmallCache from "toolbox/smallCache";
import {CurrentUser} from "authClient";

const tokenValidationCache = new SmallCache();

export const ApiTokenAPI = function () {

    function create(tokenName) {
        let parameter = {}
        parameter.tokenName = tokenName;

        return fetchProxy("apiToken/create", parameter)
    }

    async function validateToken(tokenValue) {
        const cachedResult = tokenValidationCache.get(tokenValue);
        if (cachedResult !== undefined) {
            return cachedResult
        }

        let parameter = {}
        parameter.tokenValue = tokenValue;

        const result = await fetchProxy("apiToken/validateToken", parameter);

        tokenValidationCache.put(tokenValue, result, 60);

        return result;
    }

    function remove(tokenId) {
        let parameter = {}
        parameter.tokenId = tokenId;

        return fetchProxy("apiToken/remove", parameter)
    }

    function listAll() {
        let parameter = {}

        return fetchProxy("apiToken/listAll", parameter)
    }

    function updateName(tokenId, newName) {
        let parameter = {}
        parameter.tokenId = tokenId;
        parameter.newName = newName;

        return fetchProxy("apiToken/updateName", parameter)
    }

    async function fetchProxy(url, body) {

        let jwtToken = await CurrentUser.getAuthToken()

        let headers = Fetch.getHeaderAuth(jwtToken);

        let requestOptions = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        }

        return Fetch.retry(() => fetch("https://auth.atagon.com/" + url, requestOptions), 2)
            .then((response) => response.json())
            .then(data => {
                return data
            })
            .catch((error) => console.error('Endpoint Path: ' + url + ' ' + error));

    }


    return {
        create,
        validateToken,
        updateName,
        remove,
        listAll
    }
}()
